import type { Chain } from '@wagmi/core';
import { writable, type Readable, type Writable, derived } from 'svelte/store';
import { SC_WALLET_ACCOUNT_RESOLVER, SC_WALLET_INDEX } from '$lib/web3/addresses';
import { getEthersProvider, getEthersSigner } from '$lib/web3/etherAdapters';
import type { addressType } from '$lib/types/util';

export const walletConnected: Writable<boolean> = writable(false);
export const walletLoaded: Writable<boolean> = writable(false);
export const walletAddress: Writable<any> = writable('');
export const overrideWalletAddress: Writable<string> = writable('');
export const chain: Writable<Chain | undefined> = writable();

export const cyberConnectOwnerAddress: Writable<addressType | null> = writable(null);

export const ethersProvider = derived(
	[walletConnected, walletLoaded, walletAddress],
	([$walletConnected]) => {
		if ($walletConnected) {
			return getEthersProvider();
		}
	}
);

export const ethersSigner = derived(
	[walletConnected, walletLoaded, walletAddress],
	async ([$walletConnected]) => {
		if ($walletConnected) {
			return await getEthersSigner();
		}
	}
);
export const smartWalletCreationPending: Writable<boolean> = writable(false);

export const scWalletAccountResolver: Readable<`0x${string}`> = derived(
	[walletConnected, walletLoaded, chain],
	([$walletConnected, $walletLoaded, $chain]) => {
		if (!$walletConnected || !$walletLoaded) {
			return `0x`;
		} else {
			return SC_WALLET_ACCOUNT_RESOLVER;
		}
	}
);

export const scWalletIndex: Readable<`0x${string}`> = derived(
	[walletConnected, walletLoaded, chain],
	([$walletConnected, $walletLoaded, $chain]) => {
		if (!$walletConnected || !$walletLoaded) {
			return `0x`;
		}
		if ($chain?.id == 10) {
			return SC_WALLET_INDEX;
		}
		return `0x`;
	}
);

export const loadingSmartContractWalletAuthorities: Writable<boolean> = writable(false);
export const addingSmartContractWalletAuthorities: Writable<boolean> = writable(false);
export const removingSmartContractWalletAuthorities: Writable<boolean> = writable(false);
export const smartContractWalletAuthorities: Writable<Array<string>> = writable([]);
